import PTs from 'prop-types';

import appContextTypes from './appContextTypes';

const AppContextShape = PTs.shape(appContextTypes);

export default AppContextShape;
